<div class="ds-change-item">
  <span class="ds-change-item__quantity">{{refundQuantity.value}}/{{quantity}}</span>
  <input class="ds-input"
         type="number"
         readonly
         [min]="0"
         [max]="quantity"
         [formControl]="refundQuantity"
         [value]="refundQuantity.value"
         [style.border-color]="(this.refundQuantity.errors && this.refundQuantity.value !== 0 ) ? '#E95E5B' : null">
  <div>
    <div (click)="!fullRefund && increment()">
                    <span class="db-arrow db-arrow-up" [class.disabled]="refundQuantity.value >= quantity"></span>
    </div>
    <div (click)="!fullRefund && decrement()">
                    <span class="db-arrow db-arrow-down" [class.disabled]="refundQuantity.value < 1"></span>
    </div>
    </div>
  </div>
